import {Component} from "@angular/core";
import {ComponentBase} from "../base/ComponentBase";
import {RaVersion} from "../services/configuration/ra.version";
import {StepService} from "../services/step/step.service";
import {StepStateUpdater} from "../services/step/step-state";

@Component({
    selector: "word-color",
    templateUrl: "./word-color.component.html",
    styleUrls: ["./word-color.component.scss"]
})

export class WordColorComponent extends ComponentBase  {

    public activeModal: boolean = true;

    constructor(
        public stepStateUpdater: StepStateUpdater,
        public stepService: StepService) {
        super("WordColorComponent");
    }

    ngOnInit(): void {
        super.ngOnInit();
        let recordCount = this.stepStateUpdater.recordCountProgress();
        if ( recordCount >= 2 ) {
            this.activeModal = false;
        }
    }

    public isReading(): boolean {
        return this.stepService.isReading;
    }

    public isReadingMyRecording(): boolean {
        return this.stepService.isReadingMyRecording;
    }

    public closeModal(): void {
        this.activeModal = false;
    }

}
